import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  deleteCategoryService,
  getCategoryService,
  getCoursesOfCategoryService,
} from "../../../../utils/services/course/category/categoryService";

const initialState = {
  categoryLoading: true,
  categoryCourseLoading: true,
  categoryCourseError: "",
  categoryError: "",
  categoryInfo: [],
  categoryCourseInfo: [],
  total: 0,
  searchKey: "",
  searchCourseKey: "",
  enrolledStudent: "",
  faqs: [],
  totalActiveBatches: "",
  totalCourses: "",
};

// Get
export const getCategory = createAsyncThunk(
  "/category/get",
  async (_, thunkAPI) => {
    const { searchKey } = thunkAPI.getState().category;
    const payload = {
      searchKey,
    };
    const response = await getCategoryService(payload);
    // if (response?.error) {
    //   return thunkAPI.rejectWithValue(response?.error);
    // }
    return response;
  }
);

export const getParticularCourseOfCategory = createAsyncThunk(
  "/categoryCourse/get",
  async (payload, thunkAPI) => {
    const { searchCourseKey } = thunkAPI.getState().category;
    const response = await getCoursesOfCategoryService({
      payload,
      searchCourseKey,
    });
    console.log("hello ji action", payload, searchCourseKey);
    // if (response?.error) {
    //   return thunkAPI.rejectWithValue(response?.error);
    // }
    console.log("response", payload);
    return response;
  }
);

export const deleteCategory = createAsyncThunk(
  "/category/delete",
  async (id, thunkAPI) => {
    const { isSuccess, error } = await deleteCategoryService(id);

    if (error) {
      return thunkAPI.rejectWithValue(error);
    }
    thunkAPI.dispatch(getCategory());
    return { isSuccess };
  }
);

const categorySlice = createSlice({
  name: "category",
  initialState,
  reducers: {
    searchKeyChanged(state, action) {
      state.searchKey = action.payload;
    },
    searchCourseKeyChanged(state, action) {
      state.searchCourseKey = action.payload;
    },
  },
  extraReducers: (builder) => {
    // GET
    builder.addCase(getCategory.pending, (state) => { });
    builder.addCase(getCategory.fulfilled, (state, action) => {
      state.categoryInfo = action?.payload?.data?.payload;
      console.log(action?.payload?.data?.payload, "hello1");
    });
    builder.addCase(getCategory.rejected, (state, action) => { });

    builder.addCase(getParticularCourseOfCategory.pending, (state) => { });
    builder.addCase(
      getParticularCourseOfCategory.fulfilled,
      (state, action) => {
        state.faqs = action?.payload?.data?.payload?.category?.faqs;
        state.categoryCourseInfo = action?.payload?.data?.payload?.courses;
        state.totalCourses = action?.payload?.data?.payload?.totalCourses;
        state.totalActiveBatches = action?.payload?.data?.payload?.totalActiveBatches;
        state.enrolledStudent = action?.payload?.data?.payload?.enrolledStudent;
        state.stats = action?.payload?.data?.payload?.category?.stats;
        state.trends = action?.payload?.data?.payload?.category?.trends;
        state.Rating = action?.payload?.data?.payload?.category?.averageRating;
      }
    );
    builder.addCase(
      getParticularCourseOfCategory.rejected,
      (state, action) => { }
    );
  },
});

export const {
  searchKeyChanged,
  searchCourseKeyChanged,
} = categorySlice.actions;
export default categorySlice.reducer;
